/*
 * Public API Surface of data-table
 */

export * from './lib/data-table.directive';
export * from './lib/default-sorter.component';
export * from './lib/paginator.component';
export * from './lib/bootstrap-paginator.component';
export * from './lib/data-table.module';
